import useGetSampleSize from 'app/features/inspection/hooks/useGetSampleSize';
import React from 'react';
import get from 'lodash/get';

const WithFetchSampleSize = (props: {
  skip?: boolean;
  requirement: any;
  quantity: number;
  sampleSize?: any;
  defectAccepted?: {
    critical: number;
    major: number;
    minor: number;
  };
  children: (props: {
    critical: string;
    major: string;
    minor: string;
    sampleSize: any;
    defectAccepted: any;
  }) => React.ReactNode | any;
}) => {
  const {
    children,
    requirement,
    quantity,
    sampleSize,
    defectAccepted,
    skip = false
  } = props;
  const params = React.useMemo(() => {
    return {
      quantity: quantity,
      inspectionLevel: requirement.inspectionLevel,
      inspectionAqlCritical: requirement.critical,
      inspectionAqlMajor: requirement.major,
      inspectionAqlMinor: requirement.minor
    };
  }, [requirement, quantity]);

  const response = useGetSampleSize(params, skip);

  return children({
    critical: requirement.critical,
    major: requirement.major,
    minor: requirement.minor,
    // sampleSize: response?.data?.sampleSize ?? requirement.sampleSize
    sampleSize: response?.data?.sampleSize
      ? {
          critical: get(response, 'data.aql.critical.sampleSize', 0),
          major: get(response, 'data.aql.major.sampleSize', 0),
          minor: get(response, 'data.aql.minor.sampleSize', 0)
        }
      : sampleSize,
    defectAccepted: response?.data?.sampleSize
      ? {
          critical: get(response, 'data.aql.critical.acceptanceLevel', 0),
          major: get(response, 'data.aql.major.acceptanceLevel', 0),
          minor: get(response, 'data.aql.minor.acceptanceLevel', 0)
        }
      : defectAccepted
  });
};

export default React.memo(WithFetchSampleSize);
